// extracted by mini-css-extract-plugin
module.exports = {"root":"Statusbar_root__21_qQ","ApplicationVersion":"Statusbar_ApplicationVersion__10bLZ","offline":"Statusbar_offline__Fyjn4"};